module.exports = __webpack_public_path__ + "statics/img/SellAnywhere-2.0348f16e.png";